import "./index.css";
import React from "react";
import { render } from "react-dom";
import { App } from "./App";
import { initTracking } from "./utils/tracking";
initTracking();
render(<App data-id="element-760" data-mp="1wd7ckqssqbaz" />, document.getElementById("root"));